import React from 'react';
import { useLogin } from '@refinedev/core';
import { useNavigate } from 'react-router-dom';
import {
  Row,
  Col,
  Card,
  Form,
  Input,
  Button,
  Typography,
  Alert,
  Layout,
  theme,
} from 'antd';

const { Text, Title } = Typography;

export const Login: React.FC = () => {
  const { token } = theme.useToken();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { mutateAsync: login, isLoading, error } = useLogin();

  const handleSubmit = async (values: any) => {
    try {
      const result = await login(values);
      if (result?.success) {
        navigate(result.redirectTo || '/', { replace: true });
      }
    } catch {
      // Error is already surfaced by the hook
    }
  };

  return (
    <Layout
      style={{
        minHeight: '100vh',
        background: token.colorBgLayout,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Row justify="center" align="middle" style={{ width: '100%' }}>
        <Col xs={22} sm={16} md={12} lg={8} xl={6}>
          <div style={{ textAlign: 'center', marginBottom: 32 }}>
            <div
              style={{
                width: 48,
                height: 48,
                borderRadius: 12,
                background: '#3ecf8e',
                margin: '0 auto 16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 24,
                fontWeight: 700,
                color: '#03231c',
              }}
            >
              W
            </div>
            <Title level={3} style={{ color: token.colorText, margin: 0 }}>
              Wooki AI CMS
            </Title>
            <Text style={{ color: token.colorTextSecondary }}>
              Admin dashboard for Wooki AI data
            </Text>
          </div>

          <Card
            style={{
              background: token.colorBgContainer,
              border: `1px solid ${token.colorBorder}`,
              borderRadius: 16,
            }}
            bodyStyle={{ padding: 32 }}
          >
            {error && (
              <Alert
                message={error.message || 'Login failed'}
                type="error"
                showIcon
                style={{
                  marginBottom: 24,
                }}
              />
            )}

            <Form
              form={form}
              layout="vertical"
              onFinish={handleSubmit}
            >
              <Form.Item
                label={<span style={{ color: token.colorTextSecondary }}>Email</span>}
                name="email"
                rules={[
                  { required: true, message: 'Please enter your email' },
                  { type: 'email', message: 'Please enter a valid email' },
                ]}
              >
                <Input
                  size="large"
                  placeholder="you@example.com"
                />
              </Form.Item>

              <Form.Item
                label={<span style={{ color: token.colorTextSecondary }}>Password</span>}
                name="password"
                rules={[
                  { required: true, message: 'Please enter your password' },
                ]}
              >
                <Input.Password
                  size="large"
                  placeholder="••••••••"
                />
              </Form.Item>

              <Form.Item style={{ marginTop: 24, marginBottom: 0 }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  size="large"
                  block
                  loading={isLoading}
                  style={{
                    background: '#3ecf8e',
                    borderColor: '#3ecf8e',
                    color: '#03231c',
                    fontWeight: 600,
                    borderRadius: 9999,
                    height: 44,
                  }}
                >
                  Sign in
                </Button>
              </Form.Item>
            </Form>
          </Card>

          <Text
            style={{
              display: 'block',
              textAlign: 'center',
              marginTop: 24,
              color: token.colorTextSecondary,
              fontSize: 12,
            }}
          >
            CMS access is restricted to authorized personnel only.
          </Text>
        </Col>
      </Row>
    </Layout>
  );
};
